"use strict";
/**
 * Created on 10 15 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link ExportedPriceHistory}.</p>
 *
 * @author JMe
 */


var ExportedPriceHistoryConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ExportedPriceHistoryConverter, _DataObjectConverter_);

  function ExportedPriceHistoryConverter() {
    _classCallCheck(this, ExportedPriceHistoryConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ExportedPriceHistoryConverter).apply(this, arguments));
  }

  return ExportedPriceHistoryConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ExportedPriceHistoryConverter = ExportedPriceHistoryConverter;